import { PkLiveIndicator } from '@uefadigital/panenka-react';
import type { CSSProperties, ComponentProps } from 'react';
import { memo } from 'react';

import { useTranslateFn } from '../Translate';

const LiveIndicator = ({
  label = 'live_now',
  className,
  style,
  size,
  variant = 'filled',
}: {
  label?: string;
  className?: string;
  style?: CSSProperties;
  size?: ComponentProps<typeof PkLiveIndicator>['size'];
  variant?: ComponentProps<typeof PkLiveIndicator>['variant'];
}) => {
  const t = useTranslateFn();

  return (
    <PkLiveIndicator size={size} className={className} style={style} variant={variant}>
      {t(label)}
    </PkLiveIndicator>
  );
};

export default memo(LiveIndicator);
